<template>
  <b-modal
    v-model="show"
    hide-footer
    hide-header
    centered
    size="lg"
    no-close-on-esc
  >
    <transition-group
      name="slide-next"
      tag="div"
      class="tabcontainer"
    >
      <div
        class="row tabitem"
        v-if="step === 1"
        key="1"
      >
        <div class="col-12">
          <h4 class="card-title">Carlisting mit Ihrer Domain verknüpfen</h4>
          <p class="card-subtitle mb-2 text-muted">So einfach gehts:</p>
          <b-list-group
            flush
            class="my-3"
          >
            <b-list-group-item>1. Tragen Sie Ihre Domain ein</b-list-group-item>
            <b-list-group-item>2. Tragen Sie die IP-Adresse (3.122.234.194) in den A-Record Ihres Domain-Providers ein</b-list-group-item>
            <b-list-group-item>3. Sie werden informiert, sobald Ihr Server bereitgestellt wurde</b-list-group-item>
          </b-list-group>

          <b-form-group
            label="Ihre Domain:"
            class="my-5"
          >
            <b-form-input
              :state="domainValid"
              v-model="domain"
              type="text"
              required
              placeholder="z.B. https://carlisting.de"
              @blur="validateDomain"
            ></b-form-input>
            <b-form-invalid-feedback :state="domainValid">Bitte geben Sie eine korrekt Domain an.</b-form-invalid-feedback>
          </b-form-group>
          <hr class="my-5" />
          <p>
            Tragen Sie folgende IP-Adresse ein:
            <strong>3.122.234.194</strong>
          </p>
          <b-form-checkbox
            v-model="ipSet"
            :state="ipSetValid"
            @change="validate"
          >Ich habe die IP eingetragen</b-form-checkbox>
          <b-form-invalid-feedback :state="ipSetValid">Bitte bestätigen Sie die Eingabe der IP bei Ihrem Provider</b-form-invalid-feedback>
        </div>
      </div>

      <div
        class="row align-items-center"
        style="height: 600px"
        v-if="step === 2"
        key="2"
      >
        <div class="col-12 row justify-content-center">
          <h4 class="card-title col-12 text-center">Domain hinterlegt</h4>
          <p class="text-muted col-6 text-center">
            Sie werden per E-Mail benachrichtigt, sobald Ihr Server bereitsteht. Es kann bis zu 48 Stunden dauern, bis Ihr Provider alle DNS
            Einträge für Ihre Domain geändert hat.
          </p>
          <div class="col-12 text-center">
            <b-img
              src="https://image.flaticon.com/icons/png/512/19/19973.png"
              height="300"
            />
          </div>
        </div>
      </div>
    </transition-group>
    <div class="w-100 d-flex flex-row-reverse align-self-end position-relative">
      <b-button
        variant="primary"
        @click="nextStep()"
        :disabled="loading"
      >Weiter</b-button>
      <b-button
        variant="primary"
        @click="prevStep()"
        v-if="step > 1"
      >Zurück (dev only)</b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PaymentModal',
  props: ['value'],
  data: () => ({
    step: 1,
    loading: false,
    domain: '',
    ipSet: false,
    domainValid: null,
    ipSetValid: null,
  }),

  computed: {
    ...mapState('auth', ['currentUser']),
    show: {
      get () {
        return this.value;
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    },
  },

  methods: {
    prevStep () {
      this.step -= 1;
    },
    nextStep () {
      switch (this.step) {
        case 1:
          this.setup();
          break;
        case 2:
          this.show = false;
          break;
      }
    },

    async setup () {

      const allValid = this.validate();
      if (!allValid) return;

      this.loading = true;

      await this.$store.dispatch('auth/updateUser', {
        ownDomain: this.domain,
        isOwnDomainSetUp: false,
      });

      this.loading = false;

      this.step = 2;
    },

    async validateDomain () {
      await this.$nextTick();
      if (!/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(this.domain)) {
        this.domainValid = false;
        return false
      }
      this.domainValid = true;
      return true;
    },

    async validate () {
      await this.$nextTick();
      let allValid = true;

      if (!this.ipSet) {
        this.ipSetValid = false;
        allValid = false;
      } else {
        this.ipSetValid = null;
      }

      const domainValid = await this.validateDomain();

      if (!domainValid) allValid = false;

      return allValid;
    }
  },

}
</script>

<style scoped>
.tabcontainer {
  height: 600px;
  position: relative;
  min-height: 100%;
  width: 100%;
  overflow: hidden;
}
.tabitem {
  position: absolute;
  padding: 5px;
  width: 100%;
  height: 100%;
}
.slide-next-leave-active,
.slide-next-enter-active,
.slide-prev-enter-active,
.slide-prev-leave-active {
  transition: 1s;
}
.slide-next-enter,
.slide-next-leave,
.slide-prev-leave-to {
  transform: translate(100%, 0);
}

.slide-next-leave-to,
.slide-prev-enter,
.slide-prev-leave {
  transform: translate(-100%, 0);
}
</style>